/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GCPSubnetCreateSchema
 */
export interface GCPSubnetCreateSchema {
    /**
     * 
     * @type {string}
     * @memberof GCPSubnetCreateSchema
     */
    link?: string;
    /**
     * 
     * @type {string}
     * @memberof GCPSubnetCreateSchema
     */
    name?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GCPSubnetCreateSchema
     */
    forWorkers: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GCPSubnetCreateSchema
     */
    forSchedulers: boolean;
}

/**
 * Check if a given object implements the GCPSubnetCreateSchema interface.
 */
export function instanceOfGCPSubnetCreateSchema(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "forWorkers" in value;
    isInstance = isInstance && "forSchedulers" in value;

    return isInstance;
}

export function GCPSubnetCreateSchemaFromJSON(json: any): GCPSubnetCreateSchema {
    return GCPSubnetCreateSchemaFromJSONTyped(json, false);
}

export function GCPSubnetCreateSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): GCPSubnetCreateSchema {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'link': !exists(json, 'link') ? undefined : json['link'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'forWorkers': json['for_workers'],
        'forSchedulers': json['for_schedulers'],
    };
}

export function GCPSubnetCreateSchemaToJSON(value?: GCPSubnetCreateSchema | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'link': value.link,
        'name': value.name,
        'for_workers': value.forWorkers,
        'for_schedulers': value.forSchedulers,
    };
}

